import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Button} from 'reactstrap';
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import SisMotStore from "../stores/SisMotStore";
import {Filtro} from "../../comum/components/Filtro";
import moment from "moment";

const FILTROS = ["COMPETENCIA"];
const VALIDACAO = ["COMPETENCIA_OBRIGATORIA"];

@inject("store")
@DataWrapper
@observer
export class SisMot extends Component {
    constructor(props) {
        super(props);
        this.controller = new SisMotStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("MOTs para Seguro");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro history={this.props.history}
                                controller={this.controller}
                                location={this.props.location}
                                fields={FILTROS}
                                validations={VALIDACAO}
                                onExportExcel={(filtro) => this.controller.onExportExcel(filtro)}
                                inicialDataValue={moment()} />
                    </LoadingBlockFields>
                    { this.controller.erro
                        && <MensagemErro>
                            {this.controller.erro}
                        </MensagemErro>
                    }
                </div>
            </div>
        )
    }
}